export enum CalendarTaskStatus {
  Completed = 1,
  NotStarted = 2,
  InProgress = 3,
  Deferred = 4,
  WaitingOnSomeoneElse = 5,
}

export enum CalendarTaskPriority {
  Low = 1,
  Normal = 2,
  High = 3,
}
